import React from 'react';

import { showEventTime } from '@libs/EventDetails';
import { isJobEvent } from '@libs/EventTypes';

import useEventStyle from '@hooks/CachedLists/UseEventStyle';

import EventAddress from '@components/Schedule/Calendar/EventAddress';

const ExportListEvent = ({ event, showNotes }) => {
    const eventstyle = useEventStyle(event, event.TypeName);
    const timetoshow = showEventTime(event.FromDate, event.ToDate, event.StartBreak, event.EndBreak);

    const getEventTitle = () => {
        let t = '';
        t += eventstyle.name;
        if (isJobEvent(event.TypeName) && event.OptionNumber !== 10) {
            t += ` (${event.OptionNumber})`;
        }
        t += ' - ';
        t += event.Name;
        if (event.Project) {
            if (event.Project.Name.toLowerCase() !== event.Name.toLowerCase()) {
                t += ` / ${event.Project.Name}`;
            }
        }
        return t;
    };

    return (
        <div className={`event-item ${event.Cancel ? 'cancelled' : ''}`}>
            <h4>{getEventTitle()}</h4>
            <p className="time">{timetoshow}</p>
            {event.Project && event.Project.Product && <p>PRODUCT: {event.Project.Product}</p>}
            {event.Description && <p className="description">{event.Description}</p>}
            {event.Address && (event.Address.Name || event.Address.Street || event.Address.City || event.Address.Country) && (
                <p className="location">Location:&nbsp;<EventAddress address={event.Address} inline /></p>
            )}
            {showNotes && event.Notes && <p className="notes">NOTES: {event.Notes}</p>}
        </div>
    );
};

export default ExportListEvent;
